import request, { POST } from '../../utils/request';

export default body => request('/master-data', { method: POST, body });
